import React, { useState } from 'react';
import { Typography } from '@mui/material';
import BackdropDialog from 'common/components/BackdropDialog';
import { writeBatch } from 'common/frontend/firebase/firestore';
import { api } from 'common/frontend/api';
import { ProductApi } from 'common/types';
import StoreVisibilitySettings from 'components/StoreVisibilitySettings';
import { useTranslation } from 'services/localization';

interface Props {
	productIds: string[];
	onClose: () => void;
}
const SetStoresDialog = (props: Props) => {
	const { t } = useTranslation();
	const { productIds, onClose } = props;
	const [isSaving, setIsSaving] = useState<boolean>(false);
	const [visibleInLocations, setVisibleInLocations] = useState<ProductApi['visibleInLocations']>([
		'ALL',
	]);

	const handleSave = async () => {
		setIsSaving(true);
		const batch = writeBatch();

		productIds.forEach((id) => {
			api(batch).products.doc(id).update({
				visibleInLocations,
			});
		});

		await batch.commit();
		setIsSaving(false);
	};

	return (
		<BackdropDialog
			isOpen={true}
			onClose={onClose}
			variant="primary"
			label={t('SetStoresDialog.title', 'Set stores')}
			body={
				<>
					<Typography variant="body1">
						{t(
							'SetStoresDialog.description',
							'Choose the stores the selected products should be available in.',
						)}
					</Typography>
					<StoreVisibilitySettings
						sx={{ mt: 4 }}
						value={visibleInLocations}
						onChange={setVisibleInLocations}
					/>
				</>
			}
			confirm={{
				label: t('common:actions.save', 'Save'),
				callback: handleSave,
				closeAfterDone: true,
				loading: isSaving,
			}}
			cancel={{
				label: t('common:actions.cancel', 'Cancel'),
				callback: onClose,
			}}
		/>
	);
};

export default SetStoresDialog;
